import UISelect from "@/components/ui-controls/select";
import { useEffect, useState } from "react";
import CircularLoader from "@/components/circular-loader";
import { Box } from "@mui/material";
import useManageWorkflows from "@/hooks/leads/useManageWorkflows";
import { selectLeadWorkflows } from "@/store/slices/lead/crmLeadSlice";
import { useSelector } from "react-redux";
import useManageLead from "@/hooks/leads/useManageLead";

const WorkflowsSelect = (props) => {
  const { onChange = () => {}, multiple = false, leadId } = props;
  const [selectedWorkflows, setSelectedWorkflows] = useState([]);
  const [workflows, setWorkflows] = useState([]);
  const { getWorkflowsList, workflowsList, workflowListLoading } =
    useManageWorkflows();
  const { getLeadWorkflows } = useManageLead();
  const leadWorkflows = useSelector(selectLeadWorkflows);

  useEffect(() => {
    getWorkflowsList();
    if (leadId) {
      getLeadWorkflows(leadId);
    }
  }, []);

  useEffect(() => {
    if (leadWorkflows?.activeWorkflows?.length && leadId) {
      const workflowsIds = leadWorkflows.activeWorkflows.map((wf) => wf.id);
      const mappedWf = JSON.parse(JSON.stringify(workflowsList)).map((wf) => {
        if (workflowsIds.includes(wf.id)) {
          wf.disabled = true;
          wf.tooltip = "The lead is already enrolled in this automation";
        }
        return wf;
      });
      setWorkflows(mappedWf);
      console.log(mappedWf, workflowsIds, "mappedWfmappedWf");
    } else {
      setWorkflows(workflowsList);
    }
  }, [workflowsList, leadWorkflows]);

  useEffect(
    () => () => {
      setWorkflows(workflowsList); //cleanup
    },
    []
  );

  useEffect(() => {
    console.log(workflowsList, selectedWorkflows, "flow");
    let selectedFlow = workflowsList.filter(
      (l) => l.id == selectedWorkflows
    )[0];
    let selected = selectedWorkflows;
    if (Array.isArray(selected)) {
      selected = selected.filter(Boolean);
      onChange(selected);
    } else {
      onChange(selected, selectedFlow);
    }
  }, [selectedWorkflows]);

  return (
    <>
      <Box sx={{ mt: 2 }}>
        {workflowListLoading ? (
          <CircularLoader iconSize="20px" sx={{ height: "50px" }} />
        ) : workflowsList?.length ? (
          <UISelect
            size={"medium"}
            value={selectedWorkflows || []}
            name="select-workflow"
            title="Select Automation"
            onChange={(e) => setSelectedWorkflows(e.target.value)}
            multiple={multiple}
            options={workflows}
          />
        ) : (
          <span>No automation available</span>
        )}
      </Box>
    </>
  );
};

export default WorkflowsSelect;
